/* eslint-disable max-len */
import cx from 'clsx';

// types
// styles
import { useStyles } from './shared/styles';

const Location = ({ className, color, onClick }) => {
  const classes = useStyles();

  return (
    <svg
      className={cx({
        [classes.root]: true,
        [className || '']: className,
      })}
      onClick={onClick}
      width="24"
      height="24"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.439423 0.0173333L12.9761 4.196C13.041 4.21751 13.0977 4.25845 13.1385 4.31327C13.1794 4.36809 13.2024 4.43414 13.2044 4.50247C13.2064 4.5708 13.1874 4.63811 13.1499 4.69526C13.1124 4.75242 13.0582 4.79666 12.9948 4.822L7.17276 7.15067L4.22276 13.0507C4.19274 13.1107 4.14527 13.1604 4.08657 13.193C4.02788 13.2256 3.96069 13.2398 3.89382 13.2336C3.82694 13.2274 3.7635 13.2011 3.7118 13.1583C3.6601 13.1154 3.62256 13.0579 3.60409 12.9933L0.0127567 0.424667C-0.00387884 0.366276 -0.00425087 0.304452 0.0116807 0.245865C0.0276122 0.187279 0.0592423 0.134157 0.103157 0.0922319C0.147071 0.0503072 0.201602 0.0211728 0.260864 0.00797314C0.320126 -0.00522652 0.381867 -0.0019901 0.439423 0.0173333Z"
        fill={color}
      />
    </svg>
  );
};

export default Location;
